import { FormLabel as MuiFormLabel } from "@mui/material"
import { PropsWithChildren } from "react"
import cs from "classnames"

import styles from "./Forms.module.scss"

interface Props extends PropsWithChildren {
  className?: string
}

export const FormLabel = ({ children, className }: Props) => {
  return <MuiFormLabel className={cs(styles.formLabel, className)}>{children}</MuiFormLabel>
}
